// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HorizontalScroll_wrap__SLrsG","scroll":"HorizontalScroll_scroll__1DOxj"};